// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2suTJ","ThumbZoom":"ChapterPlayer_ThumbZoom__mkova"};